import React from 'react';
import { Avatar } from '@hub/avatar';
import { UserMediumIcon } from '@hub/icon';
import { Box } from '@hub/box';
import { Text } from '@hub/text';
import { Stack } from '@hub/stack';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const AccountPaneLarge = ({
  name,
  avatarSrc,
  isLoggedIn,
  displayAccountNav,
  sx
}) => /*#__PURE__*/_jsx(Box, {
  sx: sx,
  as: "button",
  "aria-label": isLoggedIn ? 'View your account details' : 'Log into Westfield Plus',
  onClick: () => displayAccountNav(true),
  children: /*#__PURE__*/_jsx(Stack, {
    sx: {
      width: 'max-content',
      '&:hover': {
        color: 'quartz'
      },
      '&:active': {
        color: 'manatee'
      },
      '&:hover .chakra-avatar': {
        backgroundColor: 'quartz'
      },
      '&:active .chakra-avatar': {
        backgroundColor: 'manatee'
      }
    },
    align: "center",
    shouldWrapChildren: false,
    direction: "row",
    gap: 'spacing-sm',
    children: isLoggedIn ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Avatar, {
        name: name,
        src: avatarSrc
      }), /*#__PURE__*/_jsxs(Stack, {
        children: [/*#__PURE__*/_jsx(Text, {
          fontSize: "font-sm",
          tone: "strong",
          sx: {
            textAlign: 'left'
          },
          children: "Account"
        }), /*#__PURE__*/_jsx(Text, {
          fontSize: "font-xs",
          color: "licorice",
          sx: {
            textAlign: 'left'
          },
          children: "Orders, settings\u2026"
        })]
      })]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(UserMediumIcon, {
        boxSize: "size-icon-md"
      }), /*#__PURE__*/_jsxs(Stack, {
        children: [/*#__PURE__*/_jsx(Text, {
          fontSize: "font-sm",
          tone: "strong",
          sx: {
            textAlign: 'left'
          },
          children: "Westfield Plus"
        }), /*#__PURE__*/_jsx(Text, {
          fontSize: "font-xs",
          color: "licorice",
          sx: {
            textAlign: 'left'
          },
          children: "Get more everyday"
        })]
      })]
    })
  })
});